module.exports = __webpack_public_path__ + "img/skull_11.309dab32.png";